import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class CompanyService {
    constructor(private http: HttpClient) {}

    getCompany(companyId: string): Observable<Company> {
        return this.http.get<Company>(`${environment.http.companyBaseUrl}companies/${companyId}`);
    }
}

export interface Company {
    id: string;
    companyNumber: string;
    communicationLanguage: string;
    email: string;
    name: string;
    street: string;
    postalCode: string;
    city: string;
    country: string;
    countryCode: string;
    latitude: number;
    longtitude: number;
    salesOrg: string;
    maxPrioContacts: number;
    prioContacts: number;
}

export interface Contact {
    id: string;
    lastName: string;
    firstName: string;
    contactFunction: string;
    department: string;
    email: string;
    mobilePhone: string;
    phone: string;
    contactId: string;
    deleteThisContact: boolean;
}
